import * as url from 'url';
import { EmailNameAddress } from './globals/email-name-address';
import * as SessionStore from './session-store.service';

// prettier-ignore
export const CRAWLER_REGEX_PATTERNS = [
  'googlebot\/', 'Googlebot-Mobile', 'Googlebot-Image', 'Google favicon', 'Mediapartners-Google', 'bingbot', 'slurp', 'java', 'wget',
  'curl', 'Commons-HttpClient', 'Python-urllib', 'libwww', 'httpunit', 'nutch', 'phpcrawl', 'msnbot', 'jyxobot', 'FAST-WebCrawler',
  'FAST Enterprise Crawler', 'biglotron', 'teoma', 'convera', 'seekbot', 'gigablast', 'exabot', 'ngbot', 'ia_archiver', 'GingerCrawler',
  'webmon ', 'httrack', 'webcrawler', 'grub.org', 'UsineNouvelleCrawler', 'antibot', 'netresearchserver', 'speedy', 'fluffy', 'bibnum.bnf',
  'findlink', 'msrbot', 'panscient', 'yacybot', 'AISearchBot', 'IOI', 'ips-agent', 'tagoobot', 'MJ12bot', 'dotbot', 'woriobot', 'yanga',
  'buzzbot', 'mlbot', 'yandexbot', 'purebot', 'Linguee Bot', 'Voyager', 'CyberPatrol', 'voilabot', 'baiduspider', 'citeseerxbot', 'spbot',
  'twengabot', 'postrank', 'turnitinbot', 'scribdbot', 'page2rss', 'sitebot', 'linkdex', 'Adidxbot', 'blekkobot', 'ezooms', 'dotbot',
  'Mail.RU_Bot', 'discobot', 'heritrix', 'findthatfile', 'europarchive.org', 'NerdByNature.Bot', 'sistrix crawler', 'ahrefsbot', 'Aboundex',
  'domaincrawler', 'wbsearchbot', 'summify', 'ccbot', 'edisterbot', 'seznambot', 'ec2linkfinder', 'gslfbot', 'aihitbot', 'intelium_bot',
  'facebookexternalhit', 'yeti', 'RetrevoPageAnalyzer', 'lb-spider', 'sogou', 'lssbot', 'careerbot', 'wotbox', 'wocbot', 'ichiro',
  'DuckDuckBot', 'lssrocketcrawler', 'drupact', 'webcompanycrawler', 'acoonbot', 'openindexspider', 'gnam gnam spider',
  'web-archive-net.com.bot', 'backlinkcrawler', 'coccoc', 'integromedb', 'content crawler spider', 'toplistbot', 'seokicks-robot',
  'it2media-domain-crawler', 'ip-web-crawler.com', 'siteexplorer.info', 'elisabot', 'proximic', 'changedetection', 'blexbot', 'arabot',
  'WeSEE:Search', 'niki-bot', 'CrystalSemanticsBot', 'rogerbot', '360Spider', 'psbot', 'InterfaxScanBot', 'Lipperhey SEO Service',
  'CC Metadata Scaper', 'g00g1e.net', 'GrapeshotCrawler', 'urlappendbot', 'brainobot', 'fr-crawler', 'binlar', 'SimpleCrawler',
  'Livelapbot', 'Twitterbot', 'cXensebot', 'smtbot', 'bnf.fr_bot', 'A6-Indexer', 'ADmantX', 'Facebot', 'Twitterbot', 'OrangeBot',
  'memorybot', 'AdvBot', 'MegaIndex', 'SemanticScholarBot', 'ltx71', 'nerdybot', 'xovibot', 'BUbiNG', 'Qwantify', 'archive.org_bot',
  'Applebot', 'TweetmemeBot', 'crawler4j', 'findxbot', 'SemrushBot', 'yoozBot', 'lipperhey', 'y!j-asr', 'Domain Re-Animator Bot',
  'AddThis', 'RuxitSynthetic'];

//
// language codes used within the translation files (ie. files under /src/locales folder)
//
export const LANGUAGE_CODE_EN_CA = 'en-CA';
export const LANGUAGE_CODE_FR_CA = 'fr-CA';
export const DEFAULT_LANGUAGE_CODE = LANGUAGE_CODE_EN_CA;

//
// language codes as used by the backend APIs
//
export const API_LANGUAGE_CODE_EN_CA = 'en';
export const API_LANGUAGE_CODE_FR_CA = 'fr';

//
// language codes as used by Intersections Inc.
//
export const INTX_LANGUAGE_CODE_EN_CA = 1;
export const INTX_LANGUAGE_CODE_FR_CA = 2;

//
// language codes as used by the reCAPTCHA APIs
//
export const RECAPTCHA_LANGUAGE_CODE_EN_CA = 'en';
export const RECAPTCHA_LANGUAGE_CODE_FR_CA = 'fr';

//
// language codes as used by the Google Maps Embed APIs
//
export const MAP_LANGUAGE_CODE_EN_CA = 'en';
export const MAP_LANGUAGE_CODE_FR_CA = 'fr';

//
// URLs to Intersections' portal login page
//
const URL_INTX_EN_LOGIN_PAGE =
  process.env.REACT_APP_ENV === 'development'
    ? 'https://onguard.idassist.eonslg-dev.com/en/login'
    :process.env.REACT_APP_ENV === 'qa'
      ? 'https://onguard.idassist.eonslg-qa.com/en/login'
      : process.env.REACT_APP_ENV === 'uat'
      ? 'https://onguard.idassist.eonslg-uat.com/en/login'
      : 'https://onguard.idassist.com/en/login'
export const URL_INTX_LOGIN_PAGE_EN_CA = URL_INTX_EN_LOGIN_PAGE;
const URL_INTX_FR_LOGIN_PAGE =
  process.env.REACT_APP_ENV === 'development'
    ? 'https://engarde.assistidentite.eonslg-dev.com/fr/login'
    : process.env.REACT_APP_ENV === 'qa'
      ? 'https://engarde.assistidentite.eonslg-qa.com/fr/login'
      : process.env.REACT_APP_ENV === 'uat'
      ? 'https://engarde.assistidentite.eonslg-uat.com/fr/login'
      : 'https://engarde.assistidentite.com/fr/login'
export const URL_INTX_LOGIN_PAGE_FR_CA = URL_INTX_FR_LOGIN_PAGE;

const URL_IDENTITY_EN_LOGIN_PAGE =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://app.identityguard.ca/'
    : 'https://staging.app.identityguard.ca/'
export const URL_IDENTITY_LOGIN_PAGE_EN_CA = URL_IDENTITY_EN_LOGIN_PAGE;
const URL_IDENTITY_FR_LOGIN_PAGE =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://app.identityguard.ca/'
    : 'https://staging.app.identityguard.ca/'
export const URL_IDENTITY_LOGIN_PAGE_FR_CA = URL_IDENTITY_FR_LOGIN_PAGE;

//
// URLs to Intersections' account setup page
//
const URL_INTX_ACCOUNT_SETUP =
  process.env.REACT_APP_ENV !== 'production'
    ? 'https://staging.app.identityguard.ca/sign-in/set-password?token='
    : 'https://app.identityguard.ca/sign-in/set-password?token=';
export const URL_INTX_ACCOUNT_SETUP_EN_CA = URL_INTX_ACCOUNT_SETUP;
export const URL_INTX_ACCOUNT_SETUP_FR_CA = URL_INTX_ACCOUNT_SETUP;

//
// API keys for reCAPTCHA and Google Maps Embed API
//
export const SITE_KEY_RECAPTCHA =
  process.env.REACT_APP_ENV !== 'production'
    ? '6Ldo8sMUAAAAAFqzgg6SpzpTyDLZ_50hzPCwqxgQ'
    : '6Ldw4HYUAAAAABdmYvchSWu7f43fPshhgDuWj0PA';
export const EMBED_MAP_API_KEY = 'AIzaSyAp7gbzIzHddiR8q8E3sVgoumbbjS4nkdM';

//
// Google Maps URL for Contact Us page
//
// tslint:disable:max-line-length
const URL_GOOGLE_MAPS_EMBED_API = 'https://www.google.com/maps/embed/v1/place'; // IMPORTANT: do NOT end this URL with a path separator
const GOOGLE_MAPS_PLACE_ID = 'ChIJ4w7vvjDL1IkRcZTVqcsoXbc'; // Toronto's First Post Office
export const GOOGLE_MAPS_URL_CONTACT_US_EN_CA = `${URL_GOOGLE_MAPS_EMBED_API}?q=place_id:${GOOGLE_MAPS_PLACE_ID}&key=${EMBED_MAP_API_KEY}&language=${MAP_LANGUAGE_CODE_EN_CA}`;
export const GOOGLE_MAPS_URL_CONTACT_US_FR_CA = `${URL_GOOGLE_MAPS_EMBED_API}?q=place_id:${GOOGLE_MAPS_PLACE_ID}&key=${EMBED_MAP_API_KEY}&language=${MAP_LANGUAGE_CODE_FR_CA}`;
// tslint:enable:max-line-length

//
// Google Maps Places API endpoint
//
const MAPS_PLACES_API_URL = `https://maps.googleapis.com/maps/api/js?key=${EMBED_MAP_API_KEY}&libraries=places`;
export const MAPS_PLACES_API_URL_EN_CA = `${MAPS_PLACES_API_URL}&language=${MAP_LANGUAGE_CODE_EN_CA}`;
export const MAPS_PLACES_API_URL_FR_CA = `${MAPS_PLACES_API_URL}&language=${MAP_LANGUAGE_CODE_FR_CA}`;

//
// CanadaPost AddressComplete URLs
//
const ADDRESS_COMPLETE_BASE_URL = 'https://ws1.postescanada-canadapost.ca/';
export const ADDRESS_COMPLETE_STYLE_URL = `${ADDRESS_COMPLETE_BASE_URL}css/addresscomplete-2.30.min.css?key=`;
export const ADDRESS_COMPLETE_SCRIPT_URL = `${ADDRESS_COMPLETE_BASE_URL}js/addresscomplete-2.30.min.js?key=`;

//
// ISO 3166-1 Alpha-2 country codes
//
export enum CountryCode {
  CANADA = 'ca',
  USA = 'us',
  AMERICAN_SAMOA = 'as',
  PUERTO_RICO = 'pr',
  US_VIRGIN_ISLANDS = 'vi'
}

//
// host name to default language code mapping
//
export const HOST: Array<{ key: string; value: string }> = [];
switch (process.env.REACT_APP_ENV) {
  case 'development':
    HOST.push({ key: 'onguard-dev-en.escolo.ca', value: LANGUAGE_CODE_EN_CA });
    HOST.push({ key: 'onguard-dev-fr.escolo.ca', value: LANGUAGE_CODE_FR_CA });
    break;
  case 'qa':
    HOST.push({ key: 'ogprotect-qa.azurewebsites.net', value: LANGUAGE_CODE_EN_CA });
    HOST.push({ key: 'ogprotect-qa-fr.escolo.ca', value: LANGUAGE_CODE_FR_CA });
    break;
  case 'uat':
    HOST.push({ key: 'onguard-dev-en.escolo.ca', value: LANGUAGE_CODE_EN_CA });
    HOST.push({ key: 'onguard-dev-fr.escolo.ca', value: LANGUAGE_CODE_FR_CA });
    break;
  case 'preprod':
    HOST.push({ key: 'ogprotect.azurewebsites.net', value: LANGUAGE_CODE_EN_CA });
    HOST.push({ key: 'ogprotect-fr.escolo.ca', value: LANGUAGE_CODE_FR_CA });
    break;
  case 'production':
    HOST.push({ key: 'www.onguardprotect.com', value: LANGUAGE_CODE_EN_CA });
    HOST.push({ key: 'www.engardeprotection.com', value: LANGUAGE_CODE_FR_CA });
    break;
  default:
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(`Unhandled case - REACT_APP_ENV=${process.env.REACT_APP_ENV}`);
    }
    break;
}

export const ONGUARD_ERROR_LOG_EMAIL_SENDER: EmailNameAddress = {
  Name: 'OG Alerts',
  Email: 'OGAlerts@sigmaloyalty.com'
};

// ****************************************************************************
// populated in index.tsx
export const ERROR_LOG_EMAIL_RECIPIENTS: { [key: string]: EmailNameAddress[] } = {
  verifyToken: [],
  submitEnroll: [],
  confirmEnroll: [],
  intxGotoWeb: [],
  verifyEmail: []
};
export const CONTACT_FORM_EMAIL_RECIPIENTS: EmailNameAddress[] = [];
// ****************************************************************************

// ============================================================================
// IMPORTANT: all URLs MUST end with a path separator
//
//export const BASE_URL_EMAIL_API =
//  process.env.REACT_APP_ENV === 'development'
//    ? '/api/emailWithoutAttachement'
//    : process.env.REACT_APP_ENV === 'qa'
//    ? 'https://onguard-api-qa.azurewebsites.net/api/emailWithoutAttachement'
//    : process.env.REACT_APP_ENV === 'uat'
//    ? 'https://onguard-api-uat.azurewebsites.net/api/emailWithoutAttachement'
//    : process.env.REACT_APP_ENV === 'preprod'
//    ? 'https://onguard-api-preprod.azurewebsites.net/api/emailWithoutAttachement'
//    : 'https://onguard-api.azurewebsites.net/api/emailWithoutAttachement';
export const BASE_URL_EMAIL_API = '/api/emailWithoutAttachement';

  export const BASE_URL_CHECK_DUPLICATE_API =
    process.env.REACT_APP_ENV === 'development'
      ? 'https://eon-dv.azure-api.net/account/api/v1/account/check-duplicate'
      : process.env.REACT_APP_ENV === 'qa'
      ? 'https://eon-qa.azure-api.net/account/api/v1/account/check-duplicate'
      : process.env.REACT_APP_ENV === 'uat'
      ? 'https://api.eonslg-uat.com/account/api/v1/account/check-duplicate'
      : 'https://api.eonslg-prod.com/account/api/v1/account/check-duplicate';

export const BASE_URL_ACCOUNT_SETUP_EMAIL_API =
process.env.REACT_APP_ENV === 'development'
? 'https://identity.eonslg-dev.com/api/v1/credential/ForgotPassword'
: process.env.REACT_APP_ENV === 'qa'
? 'https://identity.eonslg-qa.com/api/v1/credential/ForgotPassword'
: process.env.REACT_APP_ENV === 'uat'
? 'https://identity.eonslg-uat.com/api/v1/credential/ForgotPassword'
: 'https://identity.eonslg-prod.com/api/v1/credential/ForgotPassword'

//export const BASE_URL_API =
//  process.env.REACT_APP_ENV !== 'production'
//    ? '/api/'
//    : 'https://onguard-web-api.azurewebsites.net/api/';
export const BASE_URL_API = '/api/';

//export const NEW_BASE_URL_API =
//    process.env.REACT_APP_ENV === 'development'
//    ? '/api/'
//    : process.env.REACT_APP_ENV === 'qa'
//    ? 'https://onguard-api-qa.azurewebsites.net/api/'
//    : process.env.REACT_APP_ENV === 'uat'
//    ? 'https://onguard-api-uat.azurewebsites.net/api/'
//    : process.env.REACT_APP_ENV === 'preprod'
//    ? 'https://onguard-api-preprod.azurewebsites.net/api/'
//    : 'https://onguard-api.azurewebsites.net/api/';
export const NEW_BASE_URL_API = '/api/';

export const ROUTE_PATH_HOME = '/';
export const ROUTE_PATH_VIDEO = url.resolve(ROUTE_PATH_HOME, 'video/');
export const ROUTE_PATH_ALERTS = url.resolve(ROUTE_PATH_HOME, 'alerts/');
export const ROUTE_PATH_SCAM = url.resolve(ROUTE_PATH_HOME, 'scamdetection/');
export const ROUTE_PATH_IDENTITY = url.resolve(ROUTE_PATH_HOME, 'identity/');
export const ROUTE_PATH_PROTECTION = url.resolve(ROUTE_PATH_HOME, 'protection/');
export const ROUTE_PATH_RESOURCE_CENTRE = url.resolve(ROUTE_PATH_HOME, 'resource-centre/');
export const ROUTE_PATH_TERMS_OF_USE = url.resolve(ROUTE_PATH_HOME, 'terms/');
export const ROUTE_PATH_TERMS_CONDITIONS = url.resolve(ROUTE_PATH_HOME, 'conditions/');
export const ROUTE_PATH_PRIVACY_POLICY = url.resolve(ROUTE_PATH_HOME, 'privacy/');
export const ROUTE_PATH_FAQ = url.resolve(ROUTE_PATH_HOME, 'faq/');
export const ROUTE_PATH_CONTACT = url.resolve(ROUTE_PATH_HOME, 'contact/');
export const ROUTE_PATH_ACTIVATE = url.resolve(ROUTE_PATH_HOME, 'activate/');
export const ROUTE_PATH_ACTIVATE_MAINTENANCE = url.resolve(ROUTE_PATH_HOME, 'activate-maintenance/');
export const ROUTE_PATH_ACTIVATE_STEP_1 = 'step1/'; // relative to ROUTE_PATH_ACTIVATE
export const ROUTE_PATH_ACTIVATE_STEP_2 = 'step2/'; // relative to ROUTE_PATH_ACTIVATE
export const ROUTE_PATH_ACTIVATE_SUCCESS = 'success/'; // relative to ROUTE_PATH_ACTIVATE

//To show maintenance page
const MAINTENANCE_PAGE_FLAG: boolean = false;
/// export const SHOW_MAINTENANCE_PAGE = MAINTENANCE_PAGE_FLAG && SessionStore.getActivationTokenActivated();
export function SHOW_MAINTENANCE_PAGE():boolean {
  if(SessionStore.getActivationTokenActivated())
    return MAINTENANCE_PAGE_FLAG;
  else
    return false;
}
